import React from "react";

function Logout() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 24 24"
    >
      <g fill="currentColor">
        <path
          d="M16 2h-1c-2.829 0-4.242 0-5.121.879C9 3.758 9 5.172 9 8v8c0 2.829 0 4.243.879 5.122.878.878 2.292.878 5.119.878H16c2.828 0 4.242 0 5.121-.879C22 20.243 22 18.828 22 16V8c0-2.828 0-4.243-.879-5.121C20.242 2 18.828 2 16 2z"
          opacity="0.5"
        ></path>
        <path
          fillRule="evenodd"
          d="M15.75 12a.75.75 0 00-.75-.75H4.027l1.961-1.68a.75.75 0 10-.976-1.14l-3.5 3a.75.75 0 000 1.14l3.5 3a.75.75 0 10.976-1.14l-1.96-1.68H15a.75.75 0 00.75-.75z"
          clipRule="evenodd"
        ></path>
      </g>
    </svg>
  );
}

export default Logout;
